/**
 * Legacy URL → canonical redirect map (client-side fallback for 308s).
 * Source of truth: /app/memory/SOFT404_AUDIT.md. The matching hosting-level
 * 308/410/404 rules live in /app/memory/gsc/edge_rules_DRAFT.csv.
 * Paths are matched case-sensitively, with or without a trailing slash.
 */

// Phase 3.1 canonical service slug consolidation.
const SERVICE_SLUGS = {
  "/services/ai-data-science": "/services/ai-development",
  "/services/software-web-development": "/services/custom-software-development",
  "/services/web-app-development": "/services/web-application-development",
};

// Soft 404 remediation — GSC Coverage Drilldown 2026-10-14 (approved mapping).
const LEGACY_WP = {
  "/index.html": "/",
  "/home": "/",
  "/about.html": "/about",
  "/contact.html": "/contact",
  "/contact-info": "/contact",
  "/hire-our-team": "/quote",
  "/career.html": "/careers",
  "/jobs": "/careers",
  "/partners.html": "/partnership",
  "/apply-for-resellership": "/partnership",
  "/products/acadmax": "/products/acadmax-erp",
  "/acadmax-3": "/products/acadmax-erp",
  "/build-the-roads-and-the-jobs-follow": "/products/acadmax-erp",
  "/news_imdc.html": "/products/acadmax-erp",
  "/trust-but-verify": "/products/acadmax-erp",
  "/news_ndu.html": "/products/acadmax-erp",
  "/how-brand-social-value-will-pay-a-part-in-2018-5": "/products/acadmax-erp",
  "/one-fails-forward-toward-success-1": "/products/libmax",
  "/build-the-roads-and-the-jobs-follow-1": "/portfolio/the-majestic-quran",
  "/muslim-council-of-scotland-video-presentation-in-scottish-parliament": "/portfolio/mc-scotland-presentation-at-the-scottish-parliament",
  "/imagine-the-impossible": "/portfolio/government-of-pakistan-haq-haqdaar-tak-campaign",
  "/fees-management-system-for-south-city-hospital-nursing-institute": "/portfolio/south-city-hospital-nursing-institute-fees-management-system",
  "/build-the-roads-and-the-jobs-follow-1-4-5-6": "/portfolio/darul-sehat-hospital-mobile-app",
  "/build-the-roads-and-the-jobs-follow-1-4-5": "/portfolio/paul-brooks-mobile-app",
  "/masonry": "/blog",
  "/news.html": "/blog",
  "/mobileapplicationul": "/services/mobile-app-development",
  "/2023/mobileapplicationul": "/services/mobile-app-development",
  "/2023/index.php/mobileapplicationul": "/services/mobile-app-development",
  "/businessunit-2": "/services",
  "/2023/quranclassonline": "https://quranclassonline.com/",
  "/2023/index.php/quranclassonline": "https://quranclassonline.com/",
  // Active services confirmed by owner (Phase 2 correction).
  "/azuremanagement": "/services/cloud-devops",
  "/awsservermanagement": "/services/cloud-devops",
  "/staffoutsourcing": "/services/staff-augmentation",
  "/2023/index.php/staffoutsourcing": "/services/staff-augmentation",
  // Phase 2 (performance export) — verified destinations.
  "/about-us": "/about",
  "/reseller.html": "/partnership",
  "/partners-2": "/partnership",
  "/get-quoteform": "/quote",
  "/2023/index.php/get-quoteform": "/quote",
  "/get_a_quote.html": "/quote",
  "/libmax": "/products/libmax",
  "/academic_software.html": "/products",
  "/acadmax_detailed_page.html": "/products/acadmax-erp",
  "/news_numl.html": "/products/acadmax-erp",
  "/mobileapplicationdevelopment": "/services/mobile-app-development",
  "/2023/index.php/businessunit-2": "/services",
  "/quranclassonline": "https://quranclassonline.com/",
  "/usaid-project-driven-website-data-analytics-platform-for-shrrp": "/portfolio/shrrp-us-aid-project",
  "/ninistutor-com-tutor-marketplace-mobile-app-for-ios-android": "/portfolio/ninis-tutor-official-mobile-apps",
  "/complainmanagementsystem": "/portfolio/municipal-complaint-management-system",
  // Provisionally approved by owner (pending-29 table rows 1–2).
  "/artifical_intelligence.html": "/products/libmax",
  "/softwares.html": "/services/custom-software-development",
};

export const REDIRECTS = { ...SERVICE_SLUGS, ...LEGACY_WP };

/** Returns the destination (internal path or absolute URL), or null. */
export function resolveRedirect(pathname) {
  const key = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  return REDIRECTS[key] || null;
}
